<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-top v-if="init">
      <v-flex text-xs-center v-if="errorMessage === 'unknown'">
        <p style="padding-left: 15px">Произошла неизвестная ошибка, обратитесь к администратору</p>
      </v-flex>

      <v-flex text-xs-center v-if="errorMessage === ''">
        <v-form ref="form">
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12 sm10 md8 lg7 text-xs-center style="margin-bottom:20px">
              Сейчас приложение абсолютно бесплатно. Если обнаружите ошибки, пишите на почту <a href="mailto:kastrulin@gmail.com">kastrulin@gmail.com</a>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7 v-if="paymentEnabled === true">
              <v-select
                v-model="selectedSalon"
                :items="availableSalons"
                @change="changeSalon"
                item-text="name"
                item-value="id"
                label="Компания"
                required>
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.name }}
                </template>
                <template slot='item' slot-scope='{ item }'>
                  {{ item.name }}
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 text-xs-center v-if="paymentEnabled === true">
              <v-btn v-if="selectedSalon.isPaid === false" @click="makePayment" color="#4169e1" style="color:white">Оплатить</v-btn>
              <v-btn v-if="selectedSalon.isPaid === true" @click="cancelPayment" color="#4169e1" style="color:white">Отменить</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  created () {
    this.$store.commit('showNavigation')
  }
}
</script>

<script>
import axios from 'axios'

export default {
  data: () => ({
    paymentEnabled: false,
    selectedSalon: {},
    availableSalons: [],
    errorMessage: '',
    init: false
  }),

  created () {
    this.$store.commit('showNavigation')
    this.getInfo()
  },
  methods: {
    findSalonById: function(salonId) {
      for (let i = 0; i < this.availableSalons.length; i++) {
        if (this.availableSalons[i].id === salonId) {
          return this.availableSalons[i]
        }
      }
    },
    changeSalon: function (selectedId) {
      this.selectedSalon = this.findSalonById(selectedId)
    },
    makePayment: function () {
      this.$http.post('/api/payment/pay', { salonId: this.selectedSalon.id })
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            const salon = this.findSalonById(this.selectedSalon.id)
            salon.isPaid = true
            this.$store.dispatch('showSnackbar', {
              text: 'Оплата прошла успешно',
              color: 'success'
            })
          }
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    cancelPayment: function () {
      this.$http.post('/api/payment/cancel', { salonId: this.selectedSalon.id })
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            const salon = this.findSalonById(this.selectedSalon.id)
            salon.isPaid = false
            this.$store.dispatch('showSnackbar', {
              text: 'Возврат прошел успешно',
              color: 'success'
            })
          }
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    getInfo: function () {
      this.$http.get('api/payment/getInfo')
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            this.paymentEnabled = response.data.paymentEnabled
            response.data.salons.forEach(item => {
              this.availableSalons.push({
                id: item.id,
                name: item.name,
                isPaid: item.isPaid
              })
              this.selectedSalon = this.availableSalons[0]
            })
          }
          this.init = true
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    }
  }
}
</script>
